import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-details-item-placeholder',
  templateUrl: './details-item-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class DetailsItemPlaceholderComponent {}
